<mat-toolbar class="toolbar-row">
  <div id="title-container">
    <img
      ngSrc="assets/images/secondary-thrive-mental-wellbeing-logo.webp"
      width="245"
      height="50"
      class="only-on-light"
      alt="Thrive Mental Wellbeing"
      priority />
    <img
      ngSrc="assets/images/secondary-thrive-mental-wellbeing-logo-white.webp"
      width="245"
      height="50"
      class="only-on-dark"
      alt="Thrive Mental Wellbeing"
      priority />
  </div>
</mat-toolbar>

@if (routerResolveStatus.IsLoading) {
  <mat-progress-bar mode="indeterminate" class="warn" />
}

<router-outlet />
